function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import classnames from "classnames";
import { componentStyles } from "./cluster-selection-one-step-component.scss";
import ClusterSelectionItemComponent from "./cluster-selection-item/cluster-selection-item-component";
import ClusterSelectionSignupItemComponent from "./cluster-selection-signup-item/cluster-selection-signup-item-component";
import { ELEMENT_DIMENSIONS, CLUSTERS_SELECTION_CONFIG, OPEN_SIGNUP_ITEM_ANIMATION_DURATION } from "./clusters-selection-service";
import { CLUSTER_CLICKED } from "constants/bigbrain-event-types";
import { USER_SELECTED_CLUSTER_COOKIE } from "/constants/cookies";
import { setCookie } from "/services/cookies-service";
class ClusterSelectionOneStepComponent extends PureComponent {
    selectItem(id) {
        this.setClusterItemZIndex(id, 2);
        this.setState({
            selectedClusterSelectionItemId: id
        });
        BigBrain("track", CLUSTER_CLICKED, {
            kind: id
        });
        setCookie(USER_SELECTED_CLUSTER_COOKIE, id);
    }
    clearSelectedItem() {
        const { selectedClusterSelectionItemId } = this.state;
        setTimeout(()=>{
            this.setClusterItemZIndex(selectedClusterSelectionItemId, 1);
        }, OPEN_SIGNUP_ITEM_ANIMATION_DURATION);
        this.setState({
            selectedClusterSelectionItemId: null
        });
    }
    setClusterItemZIndex(id, zIndex) {
        document.getElementById(id).style.zIndex = zIndex;
    }
    getClusterSelectionItemsWrapperHeight() {
        const numberOfItems = CLUSTERS_SELECTION_CONFIG.length;
        return numberOfItems * this.ITEM_HEIGHT;
    }
    renderClusterItems() {
        const { selectedClusterSelectionItemId } = this.state;
        return CLUSTERS_SELECTION_CONFIG.map((clusterSelection, index)=>{
            const { id } = clusterSelection;
            const isSelected = id === selectedClusterSelectionItemId;
            const style = this.getItemStyle(index, isSelected);
            const Component = isSelected ? ClusterSelectionSignupItemComponent : ClusterSelectionItemComponent;
            const onClick = isSelected ? this.clearSelectedItem : this.selectItem;
            return /*#__PURE__*/ _jsx("div", {
                id: id,
                className: classnames("cluster-selection-item-component-wrapper", {
                    selected: isSelected
                }),
                style: style,
                children: /*#__PURE__*/ _jsx(Component, _object_spread_props(_object_spread({}, clusterSelection), {
                    onClick: onClick
                }))
            }, id);
        });
    }
    getItemStyle(index, isSelected) {
        return {
            top: isSelected ? 0 : this.ITEM_HEIGHT * index,
            bottom: isSelected ? 0 : this.ITEM_HEIGHT * (CLUSTERS_SELECTION_CONFIG.length - 1 - index)
        };
    }
    getClusterSelectionItemsWrapperStyle() {
        const clusterSelectionItemsWrapperHeight = this.getClusterSelectionItemsWrapperHeight();
        const clusterSelectionItemsWrapperWidth = ELEMENT_DIMENSIONS.CLUSTER_SELECTION_ITEM_WIDTH;
        return {
            height: clusterSelectionItemsWrapperHeight,
            width: clusterSelectionItemsWrapperWidth
        };
    }
    render() {
        const clusterSelectionItemsWrapperStyle = this.getClusterSelectionItemsWrapperStyle();
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${componentStyles.__hash}` + " " + "cluster-selection-one-step-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "first-title",
                    children: "What would you like to manage ?"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "second-title",
                    children: "You can always change this later"
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: clusterSelectionItemsWrapperStyle,
                    className: `jsx-${componentStyles.__hash}` + " " + "cluster-selection-items-wrapper",
                    children: this.renderClusterItems()
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            selectedClusterSelectionItemId: null
        };
        this.ITEM_HEIGHT = ELEMENT_DIMENSIONS.CLUSTER_SELECTION_ITEM_HEIGHT + ELEMENT_DIMENSIONS.CLUSTER_SELECTION_ITEM_MARGIN;
        this.selectItem = this.selectItem.bind(this);
        this.clearSelectedItem = this.clearSelectedItem.bind(this);
    }
}
export { ClusterSelectionOneStepComponent as default };
